import FingerprintJS, { Agent, GetResult } from '@fingerprintjs/fingerprintjs';

export default new class Fingerprint {
	fingerprintApi: null | Agent = null;

	async init() {
		const fpPromise = await FingerprintJS.load();
		this.fingerprintApi = fpPromise;
	}

	async get(): Promise<string> {
		if (!this.fingerprintApi) return '';

		const fingerprintData: GetResult = await this.fingerprintApi?.get();
		const fingerprint = fingerprintData?.visitorId || '';
		return fingerprint;
	}
}();
